import { useTradingClassificationCommon } from '@eih-netbroker/common';

export const useTradingClassification = useTradingClassificationCommon;
